import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Kenyan National ID validator following Single Responsibility Principle
 */
export class KeValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Kenyan National ID',
      pattern: /^\d{7,8}$/,
      minLength: 7,
      maxLength: 8
    });
  }

  validateFormat(id) {
    // Check length
    if (id.length < this.config.minLength || id.length > this.config.maxLength) {
      return ValidationResult.invalid('Kenyan ID must be 7 or 8 digits');
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Kenyan ID must contain only digits'
    );
  }

  validateChecksum(id) {
    // Kenyan ID doesn't have a standard checksum algorithm
    // Basic validation for reasonable number ranges
    const idNum = parseInt(id);
    if (idNum < 1000000 || idNum > 99999999) {
      return ValidationResult.invalid('Invalid Kenyan ID number range');
    }

    return ValidationResult.valid('Valid Kenyan ID');
  }
}